import { ReportingImportRow } from '../reporting/reporting-import.model';

export enum LoadReportingImportInvalidRowsRequestKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
  loadOptions = 'loadOptions',
}

export type ReportingImportInvalidRowsLoadOptions = Record<string, unknown>;

export interface LoadReportingImportInvalidRowsRequest {
  [LoadReportingImportInvalidRowsRequestKeys.runId]?: string | null;
  [LoadReportingImportInvalidRowsRequestKeys.uploadActionId]?: string | null;
  [LoadReportingImportInvalidRowsRequestKeys.loadOptions]?: ReportingImportInvalidRowsLoadOptions | null;
}

export interface LoadReportingImportInvalidRowsResponse {
  rows: ReportingImportRow[];
  totalCount?: number;
  recordsTotal: number;
  recordsValid: number;
  recordsInvalid: number;
  recordsResolved: number;
}
